import React from 'react';
import { SharedNavbar } from '../components/SharedNavbar';
import { Footer } from '../components/Footer';
import { FadeIn } from '../components/FadeIn';
import { ArrowRight, Sparkles, Compass, Heart, Shield, Brain, Sun, CheckCircle2, XCircle } from 'lucide-react';
export function Sesiune1la1Page() {
  const whatsappLink = 'https://wa.me/40771946011?text=Buna%20Mihaela.%0A%0AAs%20dori%20mai%20multe%20detalii%20despre%20sau%20despre%20programele%20tale%20online%2C%20sau%20despre%20sesiunile%20de%20Coaching%201%20la%201.';
  return <>
      <SharedNavbar data-id="element-993" />
      <main className="flex-grow" data-id="element-994">
        {/* HERO SECTION */}
        <section className="relative pt-32 pb-20 md:pt-40 md:pb-28 bg-ivory overflow-hidden" data-id="element-995">
          <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 pointer-events-none" data-id="element-996">
            <div className="absolute top-[-10%] right-[-5%] w-[50%] h-[50%] bg-gold/10 rounded-full blur-3xl" data-id="element-997"></div>
            <div className="absolute bottom-[-10%] left-[-5%] w-[40%] h-[40%] bg-forest/5 rounded-full blur-3xl" data-id="element-998"></div>
            <div className="absolute top-10 left-0 text-[15vw] font-serif font-bold text-forest/[0.03] whitespace-nowrap select-none leading-none" data-id="element-999">
              COACHING
            </div>
          </div>

          <div className="max-w-[1200px] mx-auto px-6 md:px-8" data-id="element-1000">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-1001">
              <div className="flex flex-col items-center text-center order-2 lg:order-1 lg:h-full lg:justify-center" data-id="element-1002">
                <FadeIn data-id="element-1003">
                  <div className="inline-block border border-gold/40 rounded-full px-5 py-2 mb-6 bg-white/50 backdrop-blur-sm" data-id="element-1004">
                    <span className="font-display text-sm font-medium tracking-wider text-forest uppercase" data-id="element-1005">
                      Coaching 1:1
                    </span>
                  </div>
                </FadeIn>

                <FadeIn delay={0.1} data-id="element-1006">
                  <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif font-medium text-forest mb-6 leading-tight" data-id="element-1007">
                    Transformare profundă, în ritmul tău
                  </h1>
                </FadeIn>

                <FadeIn delay={0.2} data-id="element-1008">
                  <p className="text-xl md:text-2xl font-serif italic text-charcoal/80 mb-6" data-id="element-1009">
                    Spațiul tău sigur pentru claritate și vindecare
                  </p>
                </FadeIn>

                <FadeIn delay={0.3} data-id="element-1010">
                  <p className="text-lg text-charcoal/70 mb-10 max-w-[500px] leading-relaxed" data-id="element-1011">
                    Sesiuni individuale personalizate în care folosim NLP,
                    Constelații Familiale și Coaching pentru a debloca
                    potențialul tău și a vindeca rănile trecutului.
                  </p>
                </FadeIn>

                <FadeIn delay={0.4} data-id="element-1012">
                  <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 rounded-full bg-forest text-ivory font-display text-lg font-medium hover:bg-forest-light transition-colors no-underline gap-3 group shadow-lg shadow-forest/20 w-full sm:w-auto" data-id="element-1013">
                    Programează o discuție
                    <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-1014" />
                  </a>
                </FadeIn>
              </div>

              {/* Right Side - Square Image */}
              <div className="order-1 lg:order-2 relative" data-id="element-1015">
                <FadeIn direction="right" data-id="element-1016">
                  <div className="relative max-w-[500px] mx-auto" data-id="element-1017">
                    <div className="absolute -top-5 -left-5 w-full h-full rounded-[24px] border-2 border-forest/30 -z-10" data-id="element-1018"></div>
                    <div className="absolute -bottom-5 -right-5 w-full h-full rounded-[24px] bg-gold/20 -z-20" data-id="element-1019"></div>
                    <div className="absolute -top-10 -right-10 w-24 h-24 border border-gold/50 rounded-full -z-10" data-id="element-1020"></div>
                    <div className="absolute top-1/4 -left-12 w-16 h-16 bg-forest/10 rounded-full blur-md -z-10" data-id="element-1021"></div>
                    <div className="absolute bottom-1/4 -right-8 w-20 h-20 bg-gold/20 rounded-full blur-md -z-10" data-id="element-1022"></div>

                    <div className="rounded-[24px] overflow-hidden border-4 border-white shadow-2xl relative aspect-square" data-id="element-1023">
                      <img src="https://cdn.magicpatterns.com/uploads/bbhRnscRmaZkzuZMMer6an/Foto_1.jpg" alt="Mihaela Iovu Coaching" className="w-full h-full object-cover" data-id="element-1024" />
                      <div className="absolute inset-0 bg-gradient-to-t from-forest/15 to-transparent mix-blend-multiply pointer-events-none" data-id="element-1025"></div>
                    </div>
                  </div>
                </FadeIn>
              </div>
            </div>
          </div>
        </section>

        {/* 6 BENEFITS SECTION */}
        <section className="py-20 bg-white" data-id="element-1026">
          <div className="max-w-[1200px] mx-auto px-6" data-id="element-1027">
            <FadeIn data-id="element-1028">
              <div className="text-center mb-16" data-id="element-1029">
                <h2 className="text-3xl md:text-4xl font-serif text-forest mb-4" data-id="element-1030">
                  Ce obții în urma sesiunilor 1:1
                </h2>
              </div>
            </FadeIn>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1031">
              {[{
              icon: Compass,
              title: 'Claritate absolută',
              desc: 'Înțelegi exact unde ești, ce te blochează și încotro vrei să te îndrepți.'
            }, {
              icon: Shield,
              title: 'Eliberare de tipare',
              desc: 'Identificăm și rescriem programele subconștiente care te țin pe loc.'
            }, {
              icon: Heart,
              title: 'Vindecare emoțională',
              desc: 'Integrăm rănile trecutului într-un spațiu de siguranță și blândețe.'
            }, {
              icon: Brain,
              title: 'Instrumente practice',
              desc: 'Primești tehnici NLP pe care le poți folosi zilnic pentru reglare.'
            }, {
              icon: Sparkles,
              title: 'Încredere autentică',
              desc: 'Te reconectezi cu resursele tale interioare și cu propria putere.'
            }, {
              icon: Sun,
              title: 'Relații armonioase',
              desc: 'Îmbunătățești modul în care interacționezi cu tine și cu ceilalți.'
            }].map((benefit, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-1032">
                  <div className="bg-ivory p-8 rounded-2xl border border-forest/10 h-full" data-id="element-1033">
                    <benefit.icon className="w-10 h-10 text-gold-dark mb-6" data-id="element-1034" />
                    <h3 className="text-xl font-serif text-forest mb-3" data-id="element-1035">
                      {benefit.title}
                    </h3>
                    <p className="text-charcoal/70" data-id="element-1036">{benefit.desc}</p>
                  </div>
                </FadeIn>)}
            </div>
          </div>
        </section>

        {/* 4-STEP PROCESS */}
        <section className="py-20 bg-forest/5" data-id="element-1037">
          <div className="max-w-[1000px] mx-auto px-6" data-id="element-1038">
            <FadeIn data-id="element-1039">
              <div className="text-center mb-16" data-id="element-1040">
                <h2 className="text-3xl md:text-4xl font-serif text-forest mb-4" data-id="element-1041">
                  Cum lucrăm împreună
                </h2>
                <p className="text-lg text-charcoal/70" data-id="element-1042">
                  Un proces structurat, dar adaptat nevoilor tale
                </p>
              </div>
            </FadeIn>

            <div className="space-y-6 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-forest/20 before:to-transparent" data-id="element-1043">
              {[{
              step: '01',
              title: 'Sesiunea de cunoaștere',
              desc: 'O discuție gratuită de 30 de minute în care ne cunoaștem, îmi povestești despre provocările tale și vedem dacă suntem potrivite să lucrăm împreună.'
            }, {
              step: '02',
              title: 'Evaluarea și setarea intenției',
              desc: 'În prima noastră sesiune oficială, mapăm situația actuală și stabilim obiective clare pentru procesul tău de transformare.'
            }, {
              step: '03',
              title: 'Lucrul profund',
              desc: 'Folosim tehnici de NLP, Constelații Familiale și Coaching pentru a debloca emoții, a rescrie convingeri și a vindeca răni vechi.'
            }, {
              step: '04',
              title: 'Integrarea',
              desc: 'Fiecare sesiune se încheie cu pași concreți de acțiune și practici de integrare pentru a aduce transformarea în viața ta de zi cu zi.'
            }].map((item, idx) => <div key={idx} className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-1044">
                  <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-ivory bg-gold text-forest font-bold shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 shadow-sm z-10" data-id="element-1045">
                    {item.step}
                  </div>
                  <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-6 rounded-2xl bg-white shadow-sm border border-forest/10" data-id="element-1046">
                    <h3 className="font-serif text-xl text-forest mb-2" data-id="element-1047">
                      {item.title}
                    </h3>
                    <p className="text-charcoal/70" data-id="element-1048">{item.desc}</p>
                  </div>
                </div>)}
            </div>
          </div>
        </section>

        {/* FOR WHOM SECTION */}
        <section className="py-20 bg-white" data-id="element-1049">
          <div className="max-w-[1000px] mx-auto px-6" data-id="element-1050">
            <FadeIn data-id="element-1051">
              <div className="text-center mb-16" data-id="element-1052">
                <h2 className="text-3xl md:text-4xl font-serif text-forest mb-4" data-id="element-1053">
                  Este pentru tine dacă:
                </h2>
              </div>
            </FadeIn>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-1054">
              <FadeIn delay={0.1} data-id="element-1055">
                <div className="bg-forest/5 p-8 rounded-2xl h-full" data-id="element-1056">
                  <h3 className="text-2xl font-serif text-forest mb-6 flex items-center gap-3" data-id="element-1057">
                    <CheckCircle2 className="text-forest" data-id="element-1058" /> Da, te pot ajuta
                    dacă:
                  </h3>
                  <ul className="space-y-4" data-id="element-1059">
                    {['Simți că te învârți în cerc și repeți aceleași greșeli.', 'Vrei să te eliberezi de bagajul emoțional al trecutului.', 'Îți dorești relații mai sănătoase (cu tine și cu ceilalți).', 'Ești pregătită să îți asumi responsabilitatea pentru schimbare.', 'Cauți un ghidaj blând, dar ferm, orientat spre soluții.'].map((item, i) => <li key={i} className="flex items-start gap-3 text-charcoal/80" data-id="element-1060">
                        <span className="w-1.5 h-1.5 rounded-full bg-gold-dark mt-2 shrink-0" data-id="element-1061" />
                        <span data-id="element-1062">{item}</span>
                      </li>)}
                  </ul>
                </div>
              </FadeIn>

              <FadeIn delay={0.2} data-id="element-1063">
                <div className="bg-red-50 p-8 rounded-2xl h-full" data-id="element-1064">
                  <h3 className="text-2xl font-serif text-forest mb-6 flex items-center gap-3" data-id="element-1065">
                    <XCircle className="text-red-500" data-id="element-1066" /> Nu suntem potrivite
                    dacă:
                  </h3>
                  <ul className="space-y-4" data-id="element-1067">
                    {['Cauți pe cineva care să îți "repare" viața în locul tău.', 'Nu ești dispusă să faci munca interioară între sesiuni.', 'Crezi că toți ceilalți sunt de vină pentru situația ta.', 'Ai nevoie de intervenție psihiatrică pentru afecțiuni clinice severe.'].map((item, i) => <li key={i} className="flex items-start gap-3 text-charcoal/80" data-id="element-1068">
                        <span className="w-1.5 h-1.5 rounded-full bg-red-400 mt-2 shrink-0" data-id="element-1069" />
                        <span data-id="element-1070">{item}</span>
                      </li>)}
                  </ul>
                </div>
              </FadeIn>
            </div>
          </div>
        </section>

        {/* FINAL CTA */}
        <section className="relative py-24 md:py-32 bg-forest overflow-hidden text-center" data-id="element-1071">
          <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-1072">
            <div className="absolute -top-40 -left-40 w-96 h-96 bg-white/5 rounded-full blur-3xl" data-id="element-1073"></div>
            <div className="absolute -bottom-40 -right-40 w-96 h-96 bg-gold/10 rounded-full blur-3xl" data-id="element-1074"></div>
          </div>

          <div className="max-w-[800px] mx-auto px-6 relative z-10" data-id="element-1075">
            <FadeIn data-id="element-1076">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-medium text-ivory mb-6" data-id="element-1077">
                Ești pregătită să începi?
              </h2>
              <p className="text-lg md:text-xl text-ivory/80 mb-10 max-w-[600px] mx-auto" data-id="element-1078">
                Primul pas este o discuție gratuită de 30 de minute. Fără
                presiune, doar claritate.
              </p>
              <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 rounded-full bg-gold text-forest font-display text-lg font-bold hover:bg-gold-dark transition-colors no-underline gap-3 group shadow-xl shadow-black/20" data-id="element-1079">
                Programează Sesiunea Cadou
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-1080" />
              </a>
            </FadeIn>
          </div>
        </section>
      </main>
      <Footer data-id="element-1081" />
    </>;
}